<div class="list-group list-group-flush">
  <a href="#" class="list-group-item list-group-item-action active"> Home </a>
  <a href="/assets/resume/ShashiBadhuk_NodeJS_FullStack_9Years.pdf" target="_blank" mat-button color="primary" download>Download CV</a>
</div>
